import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { FaCheck } from "react-icons/fa";
import { Link, Outlet, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { getProfile, updateProfile, addTeamMember, getTeamMembers, changePassword, getAllNotificationsAdmin, getCurrentAgreement, getNebudashProfile } from "../../ApiController/ApiService";
import PlatformAgreementModal from "../Agreement/PlatformAgreementModal";
import CompleteProfileModal from "../Profile/CompleteProfileModal";
import Logo from '../../assets/Logo.svg';
import badge from '../../assets/badge2.svg';
import notification from '../../assets/notification.svg';
import settings from '../../assets/settings.svg';
import event from '../../assets/event.svg';
import profile2 from '../../assets/profile.svg';
import application from '../../assets/application.svg';
import manageIcon from "../../assets/account.svg";
import teamIcon from "../../assets/appoint.svg";
import passwordIcon from "../../assets/key.svg";
import defaultProfile from "../../assets/pic.svg";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import TeamManagementModal from "../TeamManagement/TeamManagementModal";
import { useDashboard } from "../Context/Dashboardcontext";

// Language Context
export const LanguageContext = React.createContext();

export default function AdminLayout() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [showNotifications, setShowNotifications] = useState(false);
    const notificationRef = useRef(null);
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language === 'es' ? 'Spanish' : 'English'); // Initialize based on i18n.language
    const languageRef = useRef(null);
    const languages = ["English", "Spanish"];
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const profileRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [profileImage, setProfileImage] = useState(defaultProfile);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [packageName, setPackageName] = useState('No Package');
    const [notifications, setNotifications] = useState()
    const [userData, setUserData] = useState()
    const [profile, setProfile] = useState([])
    const [profileData, setProfileData] = useState({
        fullName: '',
        firstName: '',
        lastName: '',
        email: '',
        mobileNumber: '',
        userType: '',
        userStatus: '',
        image: null
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true); // 🟦 Track initial setup

    const [isTeamModalOpen, setTeamModalOpen] = useState(false);
    const [pendingAgreement, setPendingAgreement] = useState(null);
    const [showCompleteProfile, setShowCompleteProfile] = useState(false);
    const [nebudashProfileData, setNebudashProfileData] = useState(null);
    const { FetchProfile } = useDashboard()

    useEffect(() => {
        const fetchNotifications = async () => {
            setIsLoading(true);
            try {
                const data = await getAllNotificationsAdmin();
                setNotifications(Array.isArray(data) ? data : []);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };
        fetchNotifications();
    }, []);

    console.log('notifications', notifications)

    // Sync selectedLanguage with i18n.language changes
    useEffect(() => {
        const handleLanguageChange = () => {
            setSelectedLanguage(i18n.language === 'es' ? 'Spanish' : 'English');
        };
        i18n.on('languageChanged', handleLanguageChange);
        return () => i18n.off('languageChanged', handleLanguageChange);
    }, [i18n]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (languageRef.current && !languageRef.current.contains(event.target)) {
                setShowLanguageDropdown(false);
            }
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfileDropdown(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchProfileData = async () => {
        try {
            setLoading(true);
            const data = await getProfile();

            console.log('data', data)
            setProfileData({
                fullName: data.fullName || '',
                firstName: data.firstName || '',
                lastName: data.lastName || '',
                email: data.email || '',
                mobileNumber: data.mobileNumber || '',
                userType: data.userType || '',
                userStatus: data.userStatus || '',
                image: defaultProfile
            });
            if (data.image) {
                setProfileImage(defaultProfile);
            }
            setError(null);
        } catch (err) {
            console.error('Failed to fetch profile:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (showModal) {
            fetchProfileData();
        }
    }, [showModal]);


    console.log('profileData', profileData)

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileData((prev) => ({ ...prev, [name]: value }));
    };

    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        if (!profileData.fullName || !profileData.email) {
            setError(t('errors.requiredFields'));
            return;
        }

        try {
            setLoading(true);
            setError(null);
            setSuccess(null);

            const response = await updateProfile(profileData);
            setProfileData({
                fullName: response.fullName || '',
                firstName: response.firstName || '',
                lastName: response.lastName || '',
                email: response.email || '',
                mobileNumber: response.mobileNumber || '',
                userType: response.userType || '',
                userStatus: response.userStatus || '',
                image: null
            });
            if (response.image) {
                setProfileImage(defaultProfile);
            }
            setSuccess(t('success.profileUpdated'));
            setTimeout(() => {
                setShowModal(false);
                setSuccess(null);
            }, 1500);
        } catch (err) {
            console.error('Failed to update profile:', err);
            setError(err.message || t('errors.updateProfileFailed'));
        } finally {
            setLoading(false);
        }
    };


    const fetchProfile = async () => {
        try {
            const profileData = await getProfile();
            setUserData(profileData)
            console.log('profileDataprofileData', profileData)
            setProfile(profileData)

            // 1. Check for AI Package First, fallback to standard package
            const aiPackageName = profileData?.aiPackageId?.name;
            const standardPackageName = profileData?.packageId?.name;

            // 2. Set the package name logic
            const pkgName = aiPackageName || standardPackageName || 'No Package';

            setPackageName(pkgName);
        } catch (error) {
            console.error('Failed to fetch profile:', error);
            setPackageName('No Package');
        } finally {
            setIsInitialLoading(false); // 🟦 Loading complete
        }
    };


    const checkProfileStatus = async () => {
        try {
            const res = await getNebudashProfile(); // GET /api/v1/nebudash/profile
            const profile = res?.data;
            setNebudashProfileData(profile || null);

            // Condition: Agar profile exist nahi karti
            if (!profile || (typeof profile === 'object' && Object.keys(profile).length === 0)) {
                setShowCompleteProfile(true); // Modal Open karo
                return;
            }

            // Check 1: Business Type hona zaroori hai
            const hasBusinessType = Boolean(profile.businessType?.trim());

            // Check 2: Company Name YA Store Name me se kam se kam ek hona chahiye
            const hasName = Boolean(profile.companyName?.trim() || profile.storeName?.trim());

            // Check 3: Complete Billing Address (Address, City, State, ZIP charon zaroori hain)
            const hasBillingAddress = Boolean(profile.billingAddress?.trim());
            const hasBillingCity = Boolean(profile.billingCity?.trim());
            const hasBillingState = Boolean(profile.billingState?.trim());
            const hasBillingZip = Boolean(profile.billingZip?.trim());

            // Agar koi bhi ek zaroori field missing hai toh Modal SHOW karo
            if (!hasBusinessType || !hasName || !hasBillingAddress || !hasBillingCity || !hasBillingState || !hasBillingZip) {
                setShowCompleteProfile(true); // Modal Open karo
            } else {
                setShowCompleteProfile(false); // Profile complete hai, modal chupao
            }

        } catch (error) {
            // Agar API 404 deti hai ya profile fetch fail hota hai -> Modal SHOW karo
            console.error("Profile not found or fetch failed:", error);
            setNebudashProfileData(null);
            setShowCompleteProfile(true);
        }
    };

    const checkAgreementStatus = async () => {
        try {
            const res = await getCurrentAgreement("posting_user");
            console.log("Current Agreement Response:", res);
            // If alreadyAcceptedByYou is false and agreement exists, show modal
            if (res && res.data && res.data.alreadyAcceptedByYou === false && res.data.agreement) {
                setPendingAgreement(res.data);
            } else {
                setPendingAgreement(null);
            }
        } catch (err) {
            console.error("Failed to check agreement status:", err);
        }
    };

    useEffect(() => {
        fetchProfile();
        FetchProfile();
        checkAgreementStatus();
        checkProfileStatus();
    }, []);

    const isActive = (path) => location.pathname === path;


    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    };


    const allSidebarItems = [
        { name: t('sidebar.dashboard'), path: "/dashboard/home", key: "dashboard" },
        { name: t('sidebar.orders'), path: "/dashboard/order-container", key: "orders" },
        { name: t('sidebar.exportContainer'), path: "/dashboard/export-container", key: "exportorder" },
        { name: t('sidebar.loads'), path: "/dashboard/loads", key: "loads" },
        { name: t('sidebar.dispatch'), path: "/dashboard/dispatch", key: "dispatch" },
        { name: t('sidebar.pod'), path: "/dashboard/proof-of-delivery", key: "pod" },
        { name: t('sidebar.invoices'), path: "/dashboard/invoice", key: "invoices" },
        { name: t('sidebar.reports'), path: "/dashboard/reports", key: "reports" },
        { name: t('sidebar.incidentReport'), path: "/dashboard/incident-report", key: "incidentReport" },
        { name: t('sidebar.drivers'), path: "/dashboard/drivers", key: "drivers" },
        { name: t('sidebar.clientManagement'), path: "/dashboard/client-management", key: "clientManagement" },
        { name: t('sidebar.companyProfile'), path: "/dashboard/company-profile", key: "companyProfile" },
        { name: t('sidebar.notifications'), path: "/dashboard/notification", key: "notifications" },
        { name: t('sidebar.messages'), path: "/dashboard/messages", key: "messages" },
        { name: t('sidebar.dispatcherLinks'), path: "/dashboard/link-data", key: "links" },
        { name: t('sidebar.logout'), action: handleLogout, key: "logout" }
    ];

    const permissions = profile?.permission || [];

    console.log('profile', profile)
    // Filter sidebar items based on user type
    const sidebarItems = profile?.userType === "COMPANY"
        ? allSidebarItems
        : allSidebarItems.filter(item => permissions.includes(item.key) || item.key === "logout");
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        userType: "",
    });
    const [teamMembers, setTeamMembers] = useState([]);
    const [fetchError, setFetchError] = useState(null);

    const handleViewDashboard = () => {
        setShowModal2(false);
        navigate('/dashboard');
    };

    useEffect(() => {
        const fetchTeamMembers = async () => {
            try {
                const members = await getTeamMembers();
                setTeamMembers(members);
            } catch (err) {
                setFetchError(err.message || t('errors.fetchTeamFailed'));
            }
        };
        fetchTeamMembers();
    }, [t]);

    const handleInputChange2 = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        const userTypeMap = {
            Admin: "USERADMIN",
            Dispatcher: "USERDISPATCHER",
            Driver: "DRIVER",
        };
        const payload = {
            ...formData,
            userType: userTypeMap[formData.userType] || formData.userType,
        };

        try {
            await addTeamMember(payload);
            setFormData({ fullName: "", email: "", userType: "" });
            try {
                const members = await getTeamMembers();
                setTeamMembers(members);
            } catch (err) {
                setFetchError(err.message || t('errors.refreshTeamFailed'));
            }
        } catch (err) {
            setError(err.message || t('errors.addTeamFailed'));
        } finally {
            setIsLoading(false);
        }
    };

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);

    const handleSubmit2 = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!newPassword || !confirmPassword) {
            setError(t('errors.passwordRequired'));
            setLoading(false);
            return;
        }

        if (newPassword !== confirmPassword) {
            setError(t('errors.passwordMismatch'));
            setLoading(false);
            return;
        }

        if (!termsAccepted) {
            setError(t('errors.termsRequired'));
            setLoading(false);
            return;
        }

        try {
            const data = {
                newPassword,
                confirmPassword,
            };
            await changePassword(data);
            await Swal.fire({
                icon: 'success',
                title: t('success.title'),
                text: t('success.passwordChanged'),
                confirmButtonText: t('success.confirm'),
            });
            navigate('/login');
        } catch (err) {
            setError(err.message || t('errors.resetPasswordFailed'));
        } finally {
            setLoading(false);
        }
    };

    const changeLanguage = (lang) => {
        const langCode = lang === "English" ? "en" : "es";
        i18n.changeLanguage(langCode);
        // selectedLanguage is updated via the useEffect listening to i18n.language changes
        setShowLanguageDropdown(false);
    };

    if (isInitialLoading) {
        return (
            <div 
                className="flex h-screen items-center justify-center flex-col gap-10"
                style={{
                    background: 'radial-gradient(circle at center, #1E1450 0%, #0F0A2B 100%)'
                }}
            >
                <style>
                    {`
                        @keyframes premiumPulse {
                            0%, 100% { transform: scale(1); opacity: 0.8; filter: drop-shadow(0 0 5px rgba(112, 126, 255, 0.3)); }
                            50% { transform: scale(1.05); opacity: 1; filter: drop-shadow(0 0 20px rgba(112, 126, 255, 0.7)); }
                        }
                        @keyframes shimmer {
                            0% { transform: translateX(-100%); }
                            100% { transform: translateX(100%); }
                        }
                        .premium-pulse { animation: premiumPulse 2.5s ease-in-out infinite; }
                        .shimmer-progress { animation: shimmer 1.5s infinite; }
                    `}
                </style>
                <div className="flex flex-col items-center gap-8">
                    <img src={Logo} alt={t('alt.companyLogo')} className="w-[180px] sm:w-[220px] premium-pulse" />
                    
                    <div className="flex flex-col items-center gap-4">
                        <div className="text-center">
                            <h2 className="text-xl font-bold text-white tracking-[0.2em] uppercase mb-1">
                                {t('fetchingPermissions') || 'Synchronizing'}
                            </h2>
                            <p className="text-[10px] text-[#707EFF] tracking-[0.4em] uppercase font-medium opacity-80">
                                Secure Permission Validation
                            </p>
                        </div>

                        <div className="w-64 h-[2px] bg-white/5 rounded-full relative overflow-hidden">
                            <div className="absolute top-0 left-0 w-2/3 h-full bg-gradient-to-r from-transparent via-[#707EFF] to-transparent shimmer-progress"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // 🟦 NO PERMISSION FALLBACK UI
    const hasNoPermissions = profile?.userType !== "COMPANY" && permissions.length === 0;

    if (hasNoPermissions && !isInitialLoading) {
        return (
            <div className="flex h-screen items-center justify-center relative overflow-hidden bg-[#0F0A2B]">
                {/* Background Glows */}
                <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] bg-[#4100B4]/20 rounded-full blur-[120px]"></div>
                <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] bg-[#707EFF]/10 rounded-full blur-[120px]"></div>

                <div className="z-10 bg-white/5 backdrop-blur-2xl border border-white/10 p-8 sm:p-12 rounded-[2.5rem] shadow-2xl max-w-lg w-[90%] text-center flex flex-col items-center gap-8 transition-all hover:border-white/20">
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-24 h-24 bg-red-500/10 rounded-full flex items-center justify-center border border-red-500/20 mb-2">
                            <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                            Access Restricted
                        </h1>
                    </div>

                    <div className="space-y-4">
                        <p className="text-white/80 text-lg leading-relaxed">
                            You currently have <span className="text-red-400 font-semibold">no active permissions</span> assigned to your account.
                        </p>
                        <p className="text-[#707EFF] text-base font-medium bg-[#707EFF]/10 py-3 px-6 rounded-2xl border border-[#707EFF]/20 inline-block">
                            Please contact your administrator to request access.
                        </p>
                    </div>

                    <button 
                        onClick={handleLogout}
                        className="mt-4 w-full sm:w-auto px-10 py-4 bg-white/10 hover:bg-white/20 text-white font-bold rounded-2xl transition-all border border-white/10 backdrop-blur-md hover:scale-[1.02] active:scale-[0.98]"
                    >
                        Sign Out Safely
                    </button>
                </div>
            </div>
        );
    }

    return (
        <LanguageContext.Provider value={{ selectedLanguage, changeLanguage }}>
            <div className="flex h-screen bg-[#0F0A2B] text-white overflow-hidden">
                {/* Sidebar */}
                <aside
                    style={{ boxShadow: "8px 0px 12.3px 0px #00000040" }}
                    className={`fixed inset-y-0 left-0 w-64 bg-[#4100B4] border-r border-[#2D1F6F] flex flex-col z-30 transform transition-transform duration-300 
                        ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                        lg:static lg:translate-x-0 lg:w-64 lg:flex-shrink-0`}
                >
                    <div className="p-4 flex justify-between items-center">
                        <Link to="/">
                            <img
                                src={Logo}
                                alt={t('alt.companyLogo')}
                                className="w-[170px] sm:w-[150px]"
                            />
                        </Link>


                        <button
                            className="text-2xl text-white lg:hidden"
                            onClick={() => setIsSidebarOpen(false)}
                        >
                            ×
                        </button>
                    </div>
                    <nav className="flex-1 pe-3 ps-3 pt-2 pb-2 space-y-3 overflow-y-auto hide-scrollbar">
                        {sidebarItems.map((item, idx) => (
                            <div
                                key={idx}
                                onClick={() => {
                                    setIsSidebarOpen(false);
                                    if (item.path) {
                                        navigate(item.path);
                                    } else if (item.action) {
                                        item.action();
                                    }
                                }}
                                className={`flex items-center p-2 rounded-lg text-sm cursor-pointer transition ${item.path && isActive(item.path)
                                    ? "bg-[#202224] font-semibold text-white"
                                    : "bg-[#F3F3F3] font-semibold text-[#505050]"
                                    }`}
                            >
                                {item.name}
                            </div>
                        ))}
                    </nav>
                </aside>

                {/* Main Content */}
                <div className="flex flex-col flex-1 overflow-hidden">
                    {/* Header */}
                    <header className="h-16 bg-[#4100B4] flex items-center justify-between px-4 sm:px-6 shadow-md">
                        <div className="flex items-center gap-4">
                            <button
                                className="lg:hidden text-white focus:outline-none"
                                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                                </svg>
                            </button>
                        </div>

                        <div className="flex items-center gap-4 sm:gap-6">
                            <div 
                                onClick={() => {
                                    if (['USER', 'COMPANY', 'ADMIN', 'USERADMIN'].includes(profile?.userType)) {
                                        navigate('/priceplans');
                                    }
                                }}
                                className={`bg-[#5926E7]/40 backdrop-blur-md border border-white/10 text-white rounded-full flex items-center px-4 py-2 shadow-lg h-[44px] transition-all hover:bg-[#5926E7]/60 ${
                                    ['USER', 'COMPANY', 'ADMIN', 'USERADMIN'].includes(profile?.userType) 
                                        ? 'cursor-pointer' 
                                        : 'cursor-not-allowed'
                                }`}
                                style={{
                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                                    background: 'linear-gradient(135deg, rgba(89, 38, 231, 0.4) 0%, rgba(65, 0, 180, 0.4) 100%)'
                                }}
                            >
                                <img src={badge} alt={t('alt.planBadge')} className="w-7 h-7 sm:w-8 sm:h-8 mr-2 drop-shadow-md" />
                                <div className="flex flex-col leading-tight border-l border-white/10 pl-3 mr-3">
                                    <span className="text-xs sm:text-[14px] font-bold text-white tracking-wide">{packageName}</span>
                                    <span className="text-[9px] sm:text-[11px] text-[#707EFF] font-semibold uppercase tracking-tighter">
                                        {t('upgrade')}
                                    </span>
                                </div>
                                <svg
                                    className="w-3 h-3 ml-2"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                            </div>

                            <div className="relative" ref={notificationRef}>
                                <img
                                    src={notification}
                                    alt={t('alt.notificationsIcon')}
                                    className="w-6 h-6 cursor-pointer"
                                    onClick={() => navigate('/dashboard/notification')}
                                />
                                {showNotifications && (
                                    <div style={{
                                        background: 'linear-gradient(167.8deg, #4100B4 0.5%, #1C004E 99.5%)',
                                    }} className="absolute right-0 sm:left-1/2 sm:-translate-x-1/2 mt-2 w-64 rounded-lg shadow-xl z-50 text-sm">
                                        <div className="text-white px-4 py-2 mt-2 rounded-t-lg font-semibold">{t('notifications.title')}</div>
                                        <ul>
                                            <li className="flex items-start gap-2 px-4 py-3">
                                                <img src={settings} alt={t('alt.settings')} className="w-8 h-8 rounded-full" />
                                                <div>
                                                    <p className="font-medium">{t('notifications.settings')}</p>
                                                    <p className="text-xs text-[#B5B5B5]">{t('notifications.settingsUpdate')}</p>
                                                </div>
                                            </li>
                                            <li className="flex items-start gap-2 px-4 py-3">
                                                <img src={event} alt={t('alt.event')} className="w-8 h-8 rounded-full" />
                                                <div>
                                                    <p className="font-medium">{t('notifications.eventUpdate')}</p>
                                                    <p className="text-xs text-[#B5B5B5]">{t('notifications.eventUpdateDesc')}</p>
                                                </div>
                                            </li>
                                            <li className="flex items-start gap-2 px-4 py-3">
                                                <img src={profile2} alt={t('alt.profile')} className="w-8 h-8 rounded-full" />
                                                <div>
                                                    <p className="font-medium">{t('notifications.profile')}</p>
                                                    <p className="text-xs text-gray-500">{t('notifications.profileUpdate')}</p>
                                                </div>
                                            </li>
                                            <li className="flex items-start gap-2 px-4 py-3">
                                                <img src={application} alt={t('alt.application')} className="w-8 h-8 rounded-full" />
                                                <div>
                                                    <p className="font-medium">{t('notifications.applicationError')}</p>
                                                    <p className="text-xs text-gray-500">{t('notifications.applicationErrorDesc')}</p>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="text-center text-xs text-white font-normal py-2 border-t border-[#979797] cursor-pointer hover:underline">
                                            {t('notifications.seeAll')}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="relative" ref={languageRef}>
                                <div
                                    className="flex items-center gap-1 text-white text-sm cursor-pointer"
                                    onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
                                >
                                    {selectedLanguage}
                                    <IoIosArrowDown className="text-white" />
                                </div>
                                {showLanguageDropdown && (
                                    <div className="absolute right-0 sm:left-1/2 sm:-translate-x-1/2 mt-2 w-48 bg-[#4100B4] text-white rounded-lg shadow-xl z-50 py-2 text-sm">
                                        <div className="px-4 py-2 font-semibold">{t('language.select')}</div>
                                        {languages.map((lang) => (
                                            <div
                                                key={lang}
                                                className="px-4 py-2 hover:bg-[#5926E7] cursor-pointer flex justify-between items-center"
                                                onClick={() => changeLanguage(lang)}
                                            >
                                                {lang}
                                                {selectedLanguage === lang && <FaCheck className="text-white" />}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="relative" ref={profileRef}>
                                <div
                                    className="flex items-center gap-2 text-white cursor-pointer"
                                    onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                                >
                                    <img
                                        src={profileImage}
                                        alt={t('alt.profilePicture')}
                                        className="w-8 h-8 rounded-full object-cover"
                                    />
                                    <div className="leading-tight text-xs sm:text-sm hidden sm:block">
                                        <div className="font-medium">{userData?.fullName || t('profile.dispatcherName')}</div>
                                        <div className="text-xs text-gray-300">{userData?.userType || t('profile.role')}</div>
                                    </div>
                                    <IoIosArrowDown className="text-gray-300" />
                                </div>
                                {showProfileDropdown && (
                                    <div style={{ zIndex: '10000' }} className="absolute right-0 mt-2 w-56 bg-[#4100B4] text-white rounded-lg shadow-lg py-2 text-sm">
                                        <div onClick={() => setShowModal(true)} className="px-4 py-2 hover:bg-[#5926E7] flex items-center gap-2 cursor-pointer">
                                            <img src={manageIcon} alt={t('alt.manageAccount')} className="w-4 h-4" />
                                            {t('profile.manageAccount')}
                                        </div>
                                        <div onClick={() => setTeamModalOpen(true)} className="px-4 py-2 hover:bg-[#5926E7] flex items-center gap-2 cursor-pointer">
                                            <img src={teamIcon} alt={t('alt.manageTeam')} className="w-4 h-4" />
                                            {t('profile.manageTeam')}
                                        </div>
                                        <div onClick={() => setShowModal3(true)} className="px-4 py-2 hover:bg-[#5926E7] flex items-center gap-2 cursor-pointer">
                                            <img src={passwordIcon} alt={t('alt.changePassword')} className="w-4 h-4" />
                                            {t('profile.changePassword')}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </header>

                    {/* Main Content Area */}
                    <main className="flex-1 overflow-y-auto px-4 sm:px-6 pt-4 pb-4 bg-[#0F0A2B] text-white">
                        <Outlet />
                    </main>

                    {/* Profile Management Modal */}
                    {showModal && (
                        <div style={{ zIndex: '10000' }} className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4">
                            <div style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }} className="text-white rounded-xl w-full max-w-md sm:w-[400px] p-6 relative shadow-xl">
                                <button
                                    onClick={() => setShowModal(false)}
                                    className="absolute top-2 right-4 text-2xl font-bold"
                                >
                                    ×
                                </button>
                                <h2 className="text-xl font-bold mb-4">{t('profileManagement.title')}</h2>
                                {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
                                {success && <p className="text-green-500 text-sm mb-4">{success}</p>}
                                <form onSubmit={handleProfileUpdate} className="space-y-4">
                                    <div>
                                        <label className="text-sm block mb-1">{t('profileManagement.fullName')}</label>
                                        <input
                                            type="text"
                                            name="fullName"
                                            value={profileData.fullName}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 rounded-md bg-white text-black"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm block mb-1">{t('profileManagement.email')}</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={profileData.email}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 rounded-md bg-white text-black"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm block mb-1">{t('profileManagement.phone')}</label>
                                        <input
                                            type="text"
                                            name="mobileNumber"
                                            value={profileData.mobileNumber}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 rounded-md bg-white text-black"
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm block mb-1">{t('profileManagement.position')}</label>
                                        <input
                                            type="text"
                                            name="userType"
                                            value={profileData.userType}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 rounded-md bg-white text-black"
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm block mb-1">{t('profileManagement.status')}</label>
                                        <input
                                            type="text"
                                            name="userStatus"
                                            value={profileData.userStatus}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 rounded-md bg-white text-black"
                                            disabled
                                        />
                                    </div>
                                    <div className="flex flex-col sm:flex-row gap-2">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className={`w-full bg-[#792aff] text-white py-2 rounded-md font-semibold mt-2 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        >
                                            {loading ? t('profileManagement.saving') : t('profileManagement.save')}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setShowModal(false)}
                                            className="w-full bg-gray-500 text-white py-2 rounded-md font-semibold mt-2"
                                        >
                                            {t('profileManagement.cancel')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Team Management Modal */}
                    {showModal2 && (
                        setTeamModalOpen(true)
                    )}

                    {/* Reset Password Modal */}
                    {showModal3 && (
                        <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center px-4">
                            <div style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }}
                                className="relative rounded-2xl shadow-xl w-full max-w-md sm:w-[490px] px-6 sm:px-8 py-6 text-center">
                                <button
                                    className="absolute top-2 right-4 text-2xl text-white"
                                    onClick={() => setShowModal3(false)}
                                >
                                    ×
                                </button>
                                <h2 className="text-xl sm:text-2xl font-bold text-white">{t('resetPassword.title')}</h2>
                                <p className="text-sm text-white mb-6">{t('resetPassword.description')}</p>
                                <form onSubmit={handleSubmit2}>
                                    <div className="text-left mb-4 relative">
                                        <label className="block text-white mb-1 text-sm sm:text-base">{t('resetPassword.password')}</label>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            className="w-full px-4 py-2 bg-[#F1F4F9] text-black border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                                            disabled={loading}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute right-3 top-9 text-black"
                                            disabled={loading}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                                        </button>
                                    </div>
                                    <div className="text-left mb-4 relative">
                                        <label className="block text-white mb-1 text-sm sm:text-base">{t('resetPassword.confirmPassword')}</label>
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            className="w-full px-4 py-2 bg-[#F1F4F9] text-black border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                                            disabled={loading}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            className="absolute right-3 top-9 text-black"
                                            disabled={loading}
                                        >
                                            <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
                                        </button>
                                    </div>
                                    <div className="flex items-start mb-6">
                                        <input
                                            type="checkbox"
                                            id="terms"
                                            checked={termsAccepted}
                                            onChange={(e) => setTermsAccepted(e.target.checked)}
                                            className="mr-2 mt-1"
                                            disabled={loading}
                                        />
                                        <label htmlFor="terms" className="text-sm text-white">
                                            {t('resetPassword.terms')}
                                        </label>
                                    </div>
                                    <button
                                        type="submit"
                                        className={`w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition ${loading ? 'opacity-50 cursor-not-allowed' : ''
                                            }`}
                                        disabled={loading}
                                    >
                                        {loading ? t('resetPassword.saving') : t('resetPassword.save')}
                                    </button>
                                </form>
                            </div>
                        </div>
                    )}
                </div>

                <TeamManagementModal
                    isOpen={isTeamModalOpen}
                    onClose={() => setTeamModalOpen(false)}
                    t={t}   // Pass the translation function
                />

                {pendingAgreement && (
                    <PlatformAgreementModal
                        agreementData={pendingAgreement}
                        onAccepted={() => {
                            setPendingAgreement(null);
                        }}
                    />
                )}

                {showCompleteProfile && !pendingAgreement && (
                    <CompleteProfileModal
                        isOpen={showCompleteProfile}
                        existingProfile={nebudashProfileData}
                        onClose={() => setShowCompleteProfile(false)}
                        onProfileCompleted={(updatedProfile) => {
                            setNebudashProfileData(updatedProfile);
                            setShowCompleteProfile(false);
                        }}
                    />
                )}

            </div>
        </LanguageContext.Provider>
    );
}